import React from "react"

import PropTypes from "prop-types"

import IconButton, {ICON_BUTTON_VARIANTS} from "../../../shared-components/components/IconButton/iconButton"

import "./style.scss"

const ActionRow = ({children, actionAriaLabel, actionIcon, actionOnClick, rightContent}) => (
    <div className="action-row">
        <div className="action-row-content">{children}</div>

        {rightContent}

        <IconButton
            ariaLabel={actionAriaLabel}
            icon={actionIcon}
            onClick={actionOnClick}
            variant={ICON_BUTTON_VARIANTS.ACTION_BIG}
        />
    </div>
)

ActionRow.propTypes = {
    actionAriaLabel: PropTypes.string.isRequired,
    actionIcon: PropTypes.string.isRequired,
    actionOnClick: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    rightContent: PropTypes.node,
}

export default ActionRow
